"use strict";
/* tslint:disable */
/* eslint-disable */
/**
 * RTL 2021 API (2026.08.10.)
 * RTL 2021 API (2026.08.10.)
 *
 * The version of the OpenAPI document: 1.0.0
 * Contact: rtlteam@konzorcia.hu
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
Object.defineProperty(exports, "__esModule", { value: true });
exports.UploadFormResultDataFromJSON = UploadFormResultDataFromJSON;
exports.UploadFormResultDataFromJSONTyped = UploadFormResultDataFromJSONTyped;
exports.UploadFormResultDataToJSON = UploadFormResultDataToJSON;
exports.UploadFormResultDataToJSONTyped = UploadFormResultDataToJSONTyped;
function UploadFormResultDataFromJSON(json) {
    return UploadFormResultDataFromJSONTyped(json, false);
}
function UploadFormResultDataFromJSONTyped(json, ignoreDiscriminator) {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        'uploaderName': json['uploaderName'],
        'uploaderEmail': json['uploaderEmail'],
        'uploaderComment': json['uploaderComment'],
        'filename': json['filename'],
        'uploadedFilename': json['uploadedFilename'],
        'fileSize': json['fileSize'],
    };
}
function UploadFormResultDataToJSON(value) {
    return UploadFormResultDataToJSONTyped(value, false);
}
function UploadFormResultDataToJSONTyped(value, ignoreDiscriminator = false) {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        'uploaderName': value.uploaderName,
        'uploaderEmail': value.uploaderEmail,
        'uploaderComment': value.uploaderComment,
        'filename': value.filename,
        'uploadedFilename': value.uploadedFilename,
        'fileSize': value.fileSize,
    };
}
